import React from 'react';
import AutocompleteFilter from '../common/autocompleteFilter';

const Buttons = (props) => {
  return (
    <section className="module-filter top">
      <div className="flex">
        <div className="flex filter-box">
          <h2 id="select-filter" className="container-filter-h2 column-filter">
            <span>{props.language.account.filterDriver.show}:</span>
            <div>{props.language.account.filterDriver.activeDriver}</div>
          </h2>
          <ul className="container-filter-ul">
            <li className="container-filter-li">
              <i className="fas fa-caret-down" />
              <ul>
                <li data-select="a" onClick={props.handleHomologation}>
                  {props.language.account.filterDriver.activeDriver}
                </li>
                <li data-select="e" onClick={props.handleHomologation}>
                  {props.language.account.filterDriver.allDriver}
                </li>
                <li data-select="b" onClick={props.handleHomologation}>
                  {props.language.account.filterDriver.associatedDriver}
                </li>
                <li data-select="c" onClick={props.handleHomologation}>
                  {props.language.account.filterDriver.pendingDriver}
                </li>
                <li data-select="d" onClick={props.handleHomologation}>
                  {props.language.account.filterDriver.desactiveDriver}
                </li>
              </ul>
            </li>
          </ul>
        </div>
        {props.filter.map((item, i) => {
          // create options for autocomplete
          const options = item.tags.map((value) => ({
            key: value.tag,
            value: value.tag
          }));
          // add "All" option to the beginning of the list
          options.unshift({
            key: '*',
            value: props.language.all
          });

          return (
            <AutocompleteFilter
              key={`autocompleteFilter-key-${i}`}
              id={`select-filter-${item.name}`}
              label={props.language.filter[item.name.toLowerCase()]}
              selectedKey={'*'}
              options={options}
              onChange={props.handleTagsFilter}
              dataAttributes={{
                "data-select": (option) => option.key,
                "data-category": item.name.toLowerCase(),
                "data-parent": `select-filter-${item.name}`,
              }}
            />
          );
        })}
      </div>
      <div>
        <div className="box-form">
          {props.buttonShow && (
            <ul className="buttom_menu">
              <li>
                {props.language.account.createDriver.create}
                <ul>
                  <li>
                    <a data-close="ok" onClick={props.handleModal}>
                      {props.language.account.createDriver.create}
                    </a>
                  </li>
                  <li>
                    <a data-close="ok" onClick={props.handleModalUpdate}>
                      {props.language.account.createDriver.import}
                    </a>
                  </li>
                  <li>
                    <a data-close="ok" onClick={props.handleModalDownload}>
                      {props.language.account.createDriver.download}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          )}
        </div>
      </div>
    </section>
  )
};

export default Buttons;



// WEBPACK FOOTER //
// ./source/client/components/account_driver/buttons.jsx